import {
    CREATE_ACCESS_POINT,
    CREATE_ACCESS_POINT_FAILURE,
    CREATE_ACCESS_POINT_SUCCESS,
} from 'store/actions/types';

export const createAccessPoint = (payload) => {
    return {
        type: CREATE_ACCESS_POINT,
        payload: payload,
    };
};

export const createAccessPointFailure = (error) => {
    return {
        type: CREATE_ACCESS_POINT_FAILURE,
        error: error,
    };
};
export const createAccessPointSuccess = (response) => {
    return {
        type: CREATE_ACCESS_POINT_SUCCESS,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/createAccessPoint.js